import { CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';

import { FormLineLayout } from 'app/components/commons/Form/FormLineLayout/FormLineLayout';
import { useGetHotel } from 'app/hooks/data/hotels/useHotel';

type StripeSectionProps = {
  hotelId: number;
};

export const StripeSection = ({ hotelId }: StripeSectionProps) => {
  const { data: hotel } = useGetHotel(hotelId);

  return (
    <>
      <FormLineLayout label="Onboarding" rightClassName="stripe-ready">
        {hotel?.pspOnboardingDone ? (
          <>
            <CheckCircleOutlined />
            Done
          </>
        ) : (
          <>
            <CloseCircleOutlined />
            Not done
          </>
        )}
      </FormLineLayout>
      <FormLineLayout label="Ready for payments" rightClassName="stripe-ready">
        {hotel?.pspOnboardingDone ? (
          <>
            <CheckCircleOutlined />
            Yes
          </>
        ) : (
          <>
            <CloseCircleOutlined />
            No
          </>
        )}
      </FormLineLayout>
    </>
  );
};
